module.exports = __webpack_public_path__ + "static/phone-directed-f3526a84d3fb971b35b9ebb73ba0cec1.svg";